module.exports = __webpack_public_path__ + "img/platforminfo_4.85966616.png";